import React from "react";
import Roles from "../modules/Roles/Roles";

export default function RolesPage() {
  return <Roles />;
}
